module.exports = __webpack_public_path__ + "img/ENG.f99573c1.png";